import React, { useState, useRef } from 'react';
import { useLang } from '../context/LangContext';
import api from '../utils/api';
import './PageCommon.css';

export default function Media() {
  const { lang } = useLang();
  const [uploading, setUploading] = useState(false);
  const [files, setFiles] = useState([]);
  const [msg, setMsg] = useState('');
  const fileInputRef = useRef(null);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    setMsg('');
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await api.post('/user/return_media_url', formData, {
        transformRequest: [(data, headers) => {
          delete headers['Content-Type'];
          return data;
        }],
      });
      if (res.data?.success) {
        const url = res.data.url || res.data.data;
        setFiles(prev => [{ name: file.name, url, type: file.type, date: new Date() }, ...prev]);
        setMsg(lang === 'en' ? 'File uploaded!' : '¡Archivo subido!');
      } else {
        setMsg(res.data?.msg || 'Error');
      }
    } catch {
      setMsg(lang === 'en' ? 'Upload error' : 'Error al subir');
    }
    setUploading(false);
    e.target.value = '';
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  return (
    <div className="page">
      <div className="page__header">
        <div>
          <h1>{lang === 'en' ? 'Media Library' : 'Biblioteca de Medios'}</h1>
          <p>{lang === 'en' ? 'Upload and manage images, videos, and documents' : 'Sube y gestiona imágenes, videos y documentos'}</p>
        </div>
        <label className="page__btn-primary page__btn-primary--label">
          {uploading ? '...' : (lang === 'en' ? '+ Upload File' : '+ Subir Archivo')}
          <input ref={fileInputRef} type="file" className="page__file-input" onChange={handleUpload} disabled={uploading} />
        </label>
      </div>

      {msg && <div className="page__msg" role="status">{msg}</div>}

      {files.length === 0 ? (
        <div className="page__empty">
          <span className="page__empty-icon">🖼️</span>
          <h3>{lang === 'en' ? 'No files uploaded' : 'No hay archivos subidos'}</h3>
          <p>{lang === 'en' ? 'Upload images, videos, or documents to use in campaigns and responses' : 'Sube imágenes, videos o documentos para usar en campañas y respuestas'}</p>
        </div>
      ) : (
        <div className="page__grid page__grid--media">
          {files.map((f, i) => (
            <div className="page__card" key={`${f.name}-${f.url}-${i}`}>
              <div className="page__card-header">
                <h3>{f.name}</h3>
              </div>
              {f.url && <p className="page__card-url">{f.url}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
